import styled from "styled-components";
import { addMinutes, canAdvanceTime, displayTime, isBefore, TimeInterface } from "../../../../interface/Time";
import { useContext, useEffect, useRef, useState } from "react";
import Popover from '@mui/material/Popover';
import TextField from '@mui/material/TextField';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import React from "react";
import { SLEEP_TIME } from "../../../../constants/constants";
import { Button, Popper } from "@mui/material";
import { AppContext } from "../../../../contexts/AppContext";
import "./style.css"
import IconArrow from "./IconArrow";

interface Props {
  time: TimeInterface,
  targetTime: TimeInterface,
  setTargetTime: React.Dispatch<React.SetStateAction<TimeInterface>>,
  onEndRound: () => void,
  triggerAction: (newTime: TimeInterface, newPoints?: number) => void,
  canTrigger: boolean
}


const AdvanceTime = ({ time, targetTime, setTargetTime, onEndRound, triggerAction, canTrigger }: Props) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [anchorEl2, setAnchorEl2] = useState<HTMLElement | null>(null);
  const [endRound, setEndRound] = useState<boolean>(false);
  const buttonRef = useRef(null)

  const [fontColor, setFontColor] = useState<string>("black");

  const { defaultValues } = useContext(AppContext);

  useEffect(() => {
    if (defaultValues) { setFontColor(defaultValues["theme"]["color_one"]); }
  }, [])

  // Set End of the round when time is passed bedtime.
  useEffect(() => {
    const canAdvance = canAdvanceTime(time);
    const shouldEndRound = !canAdvance;
    console.log(`[AdvanceTime] Time changed to ${time.hours}:${time.minutes.toString().padStart(2, '0')}`);
    console.log(`[AdvanceTime] SLEEP_TIME is: ${SLEEP_TIME.hours}:${SLEEP_TIME.minutes.toString().padStart(2, '0')}`);
    console.log(`[AdvanceTime] Current time is before sleep time: ${isBefore(time, SLEEP_TIME)}`);
    console.log(`[AdvanceTime] Can advance time: ${canAdvance}`);
    console.log(`[AdvanceTime] Should end round: ${shouldEndRound}`);
    console.log(`[AdvanceTime] Setting endRound to: ${shouldEndRound}`);
    setEndRound(shouldEndRound);
  }, [time]);

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;


  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (event.currentTarget.parentElement instanceof HTMLElement && isBefore(time, SLEEP_TIME))
      setAnchorEl(event.currentTarget.parentElement.parentElement);
  };


  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleButtonClicked = (event: React.MouseEvent<HTMLElement>) => {
    console.log(`[AdvanceTime] "Step forward to" button clicked`);
    console.log(`[AdvanceTime] Target time: ${targetTime.hours}:${targetTime.minutes.toString().padStart(2, '0')}`);
    console.log(`[AdvanceTime] Can trigger: ${canTrigger}`);
    console.log(`[AdvanceTime] Current time: ${time.hours}:${time.minutes.toString().padStart(2, '0')}`);
    triggerAction(targetTime);
  };

  // Debug logging for render
  console.log(`[AdvanceTime] Rendering component - endRound: ${endRound}, anchorEl2: ${anchorEl2 ? 'exists' : 'null'}`);

  return (
    <div className="advance-time">
      <div style={{ "display": "flex" }} ref={setAnchorEl2}>
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          onClose={handleClose}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <TimePicker
              value={dayjs().hour(targetTime.hours).minute(targetTime.minutes)}
              onChange={(newValue) => {
                if (newValue) {
                  setTargetTime({ 
                    hours: newValue.hour(), 
                    minutes: newValue.minute() 
                  });
                }
              }}
              slotProps={{
                textField: {
                  size: 'small'
                }
              }}
            />
          </LocalizationProvider>
        </Popover>
        
        <Button
          className="no-border font-list new-button desktop-version"
          startIcon={<IconArrow />}
          ref={buttonRef}
          variant="contained"
          sx={{ backgroundColor: "transparent" }}
          onClick={handleButtonClicked}
          disabled={!canAdvanceTime(time) || !canTrigger}
        >
          Avancer d'une heure
        </Button>
        <Button
          className="no-border font-list new-button mobile-version"
          startIcon={<IconArrow />}
          ref={buttonRef}
          variant="contained"
          sx={{ backgroundColor: "transparent" }}
          onClick={handleButtonClicked}
          disabled={!canAdvanceTime(time) || !canTrigger}
        >
          Avancer
        </Button>
        {/*
        <Button
          className="no-border font-list font-underline"
          ref={buttonRef}
          variant="contained"
           startIcon={<IconArrow />}
          sx={{ backgroundColor: "transparent", marginLeft: ".2em", width: "100%" }}
          onClick={handleClick}
          disabled={!isBefore(time, SLEEP_TIME) || !canTrigger}
        > 
          Avancer d'une heure
          
          {displayTime(targetTime)}
          
        </Button>
        */}
      </div>
      <Popper id="endRound" open={endRound} anchorEl={anchorEl2} placement="left">
        <Button variant="contained" sx={{ mr: 1 }} onClick={() => {
          console.log(`[AdvanceTime] "Fin de la ronde" button clicked`);
          onEndRound();
        }}>Fin de la ronde</Button>
      </Popper>
    </div>
  );
};


const Container = styled.div`
    display: flex;
`;

const ValueField = styled.div`
    flex-grow: 1;
    padding: .2em;
`


export default AdvanceTime;